import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'

import {
  SetupActivityModal,
  ReviseMessageModal,
  SetupParticipantEventJourneyModal,
  TrainingAndPracticeModal
} from 'components/modals'
import {
  ActivityItemWrap,
  RPItemWrap,
  AJItemWrap
} from 'components/sections/dashboard'
import { CardLoader } from 'components/loaders'
import MODALS from 'constants/layout/modals'
import { AJ_EVENT_CATEGORIES, ACTIVITY_SECTIONS, CONFIGURATION_KEYS, AWARD_TYPES, LEVELS } from 'constants/enums'
import { modal } from 'helpers/decorators'
import styles from './activities-list.styl'
import { initialValuesActivity } from 'models/activities'
import { createGroupActivities } from 'helpers/selectors'
import config from 'config'
import { compose } from 'recompose'
import { apiConfiguration } from '../../../../helpers/decorators/api'
import { connect } from 'react-redux'
import { apiBadges } from '../../../../helpers/decorators/api/dashboard'

let groupActivities = null

const enhance = compose(
  modal.trigger(),
  apiBadges({ loadAwardBadges: true, loadBadgesProgress: true }),
  apiConfiguration({ getValue: CONFIGURATION_KEYS.isBadgesEnabled.id }),
  connect(({ api }) => ({
    configuration: api.configuration
  }))
)

class ActivitiesList extends PureComponent {
  static propTypes = {
    awardType: PropTypes.object,
    awardLevel: PropTypes.object,
    awardStartDate: PropTypes.string,
    activities: PropTypes.array,
    ajProgress: PropTypes.array,
    canSetupSections: PropTypes.bool,
    mustBeMajor: PropTypes.bool,
    showMajor: PropTypes.bool,
    notification: PropTypes.func.isRequired,
    onOpen: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
    awardId: PropTypes.number,
    residentialProject: PropTypes.object,
    modalObj: PropTypes.object,
    aJValues: PropTypes.object,
    isBlocked: PropTypes.bool,
    notifyBlockedAward: PropTypes.func,
    configuration: PropTypes.object,
    badges: PropTypes.object
  }

  static defaultProps = {
    showMajor: false,
    mustBeMajor: false
  }

  constructor() {
    super()
    groupActivities = createGroupActivities()
  }

  ensureNotBlocked = callback => {
    const { isBlocked, notifyBlockedAward } = this.props

    if (isBlocked) {
      notifyBlockedAward()
    } else {
      callback()
    }
  }

  handleOpenNewActivity = activity =>
    this.ensureNotBlocked(() => this.props.onOpen(MODALS.ADD_ACTIVITY, null, { activity }))

  handleShowReviseMessageActivity = activity =>
    this.ensureNotBlocked(() => this.props.onOpen(MODALS.REVISE_MESSAGE, null, { activity }))

  handleShowReviseMessageRP = residentialProject =>
    this.ensureNotBlocked(() => this.props.onOpen(MODALS.REVISE_MESSAGE, null, { residentialProject }))

  handleShowReviseMessageAJ = journey =>
    this.ensureNotBlocked(() => this.props.onOpen(MODALS.REVISE_MESSAGE, null, { journey }))

  handleOpenDetailActivity = id =>
    id &&
    this.ensureNotBlocked(() => this.props.push(
      `${config.publicPath}/dashboard/awards/${this.props.awardId}/activity/${id}/logs`
    ))

  handleOpenDetailRP = id =>
    id &&
    this.ensureNotBlocked(() => this.props.push(
      `${config.publicPath}/dashboard/awards/${this.props.awardId}/residential-project/${id}/report`
    ))

  handleOpenNewRP = id =>
    id &&
    this.ensureNotBlocked(() => this.props.push(
      `${config.publicPath}/dashboard/awards/${this.props.awardId}/residential-project/${id}/new`
    ))

  handleOpenDetailAJ = ({ categoryUrl, id } = {}) => {
    if (!this.props.awardId || !categoryUrl) {
      return
    }

    const url = `${config.publicPath}/dashboard/awards/${this.props
      .awardId}/adventurous-journey/${categoryUrl}/${id}`

    this.ensureNotBlocked(() => this.props.push(url))
  }

  handleOpenTrainAndPrep = () =>
    this.ensureNotBlocked(() => this.props.push(
      `${config.publicPath}/dashboard/awards/${this.props
        .awardId}/adventurous-journey/${AJ_EVENT_CATEGORIES.trainingAndPrep
        .url}/${AJ_EVENT_CATEGORIES.trainingAndPrep.index}`
    ))

  handleOpenNewJourney = journey => {
    journey &&
      this.ensureNotBlocked(() => this.props.onOpen(MODALS.ADD_PE_JOURNEY, null, {
        journey
      }))
  }

  handleOpenNewTrainAndPrep = journey =>
    journey &&
    this.ensureNotBlocked(() => this.props.onOpen(MODALS.PREPARATION_AND_TRAINING, null, {
      journey
    }))

  renderSection = (section, awardLevel) => {
    const isMultiple = section.length > 1

    const isBadgesEnabled = get(this.props.configuration, `values[${CONFIGURATION_KEYS.isBadgesEnabled.id}].booleanValue`)

    const awardBadges = get(this.props.badges, 'awardBadges')

    return (
      <ActivityItemWrap
        multiple={isMultiple}
        key={section[0].id}
        activity={isMultiple ? section : section[0]}
        notification={this.props.notification}
        canSetupSections={this.props.canSetupSections}
        onOpenDetail={this.handleOpenDetailActivity}
        onOpenNewActivity={this.handleOpenNewActivity}
        onShowReviseMessage={this.handleShowReviseMessageActivity}
        isBlocked={this.props.isBlocked}
        notifyBlockedAward={this.props.notifyBlockedAward}
        isBadgesEnabled={isBadgesEnabled}
        awardBadges={awardBadges}
        awardLevel={awardLevel}
      />
    )
  }

  render() {
    const {
      awardType,
      awardLevel,
      awardStartDate,
      residentialProject,
      canSetupSections,
      notification,
      mustBeMajor,
      ajProgress,
      activities,
      showMajor,
      modalObj,
      awardId,
      aJValues,
      loading,
      loaded
    } = this.props

    const isSimplified = get(awardType, 'value') === AWARD_TYPES.simplified.id
    const isBronze = get(awardLevel, 'value') === LEVELS.BRONZE.id
    const isSimplifiedBronze = isSimplified && isBronze
    const activity = get(modalObj, 'data.activity')
    const journey = get(modalObj, 'data.journey')
    const openSetupClean = get(modalObj, 'data.resetOnMount')

    const isInitialJourney = [
      AJ_EVENT_CATEGORIES.qualification.index,
      AJ_EVENT_CATEGORIES.practice.index
    ].includes(get(journey, 'id'))

    const grouped = activities && groupActivities(activities)

    const sections = [
      get(grouped, ACTIVITY_SECTIONS.skill.id),
      get(grouped, ACTIVITY_SECTIONS.physical_recreation.id),
      get(grouped, ACTIVITY_SECTIONS.service.id)
    ]

    return (
      <div className={styles.wrap}>
        {!loaded && loading && <CardLoader />}

        {loaded && (
          <div>

            {sections.map(section => section && this.renderSection(section, awardLevel))}

            <AJItemWrap
              aJValues={aJValues}
              onOpenDetail={this.handleOpenDetailAJ}
              onOpenTrainAndPrep={this.handleOpenTrainAndPrep}
              ajProgress={ajProgress}
              canSetupSections={canSetupSections}
              notification={notification}
              onOpenNewJourney={this.handleOpenNewJourney}
              onOpenNewTrainAndPrep={this.handleOpenNewTrainAndPrep}
              onShowReviseMessage={this.handleShowReviseMessageAJ}
              isBlocked={this.props.isBlocked}
              notifyBlockedAward={this.props.notifyBlockedAward}
              awardType={awardType}
            />

            {residentialProject && (
              <RPItemWrap
                residentialProject={residentialProject}
                onShowReviseMessage={this.handleShowReviseMessageRP}
                onOpenDetail={this.handleOpenDetailRP}
                onOpenNewRP={this.handleOpenNewRP}
                canSetupSections={canSetupSections}
                notification={notification}
                isBlocked={this.props.isBlocked}
                notifyBlockedAward={this.props.notifyBlockedAward}
              />
            )}
          </div>
        )}

        <SetupActivityModal
          activity={activity}
          initialValues={initialValuesActivity(
            activity,
            showMajor,
            mustBeMajor,
            isSimplifiedBronze
          )}
          modalId={MODALS.ADD_ACTIVITY}
          mustBeMajor={mustBeMajor}
          showMajor={showMajor}
          isSimplifiedBronze={isSimplifiedBronze}
          awardId={awardId}
        />

        {journey && (
          <SetupParticipantEventJourneyModal
            awardId={awardId}
            awardLevel={awardLevel}
            awardStartDate={awardStartDate}
            eventCategory={get(journey, 'ajEventCategoryType')}
            modalId={MODALS.ADD_PE_JOURNEY}
            title={
              <FormattedMessage
                id="moduleTitle.new_event_journey"
                defaultMessage="New {event} Journey"
                values={{
                  event: get(journey, 'ajEvent.ajEventCategory.translationText')
                }}
              />
            }
            pEId={!isInitialJourney && get(journey, 'id')}
            journey={openSetupClean ? {} : journey}
          />
        )}

        {journey && (
          <TrainingAndPracticeModal
            modalId={MODALS.PREPARATION_AND_TRAINING}
            awardId={awardId}
          />
        )}

        <ReviseMessageModal
          push={this.props.push}
          awardId={awardId}
          modalId={MODALS.REVISE_MESSAGE}
        />
      </div>
    )
  }
}

export default enhance(ActivitiesList)
